export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
})

export function bullets(items: string[]): string {
  if (!items) return ""
  return items
    .map(
      (c) =>
        `<span class="inline-flex m-0.5 items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">${c}</span>`
    )
    .join("")
}
